export default __webpack_public_path__ + "static/eYKJOGtp-16985dd11d07b0c79c54769c7149d640.svg";